import React from 'react';

import { Loading, Separator } from '@crossnokaye/ux-common';
import { SettingsItem, SettingsTemplate } from '@crossnokaye/ux-common';
import { ConditionalRender } from '@crossnokaye/ux-smarts';

import {
  CreateTokenCard,
  RevokeAllAction,
  TokenManagementTable,
} from '@/features/tokens/components';
import { useListUserRefreshTokens } from '@/features/tokens/hooks';
import { useAuthUser } from '@/providers';

export const TokensPage: React.FC = () => {
  const { user } = useAuthUser();

  const { data: tokens } = useListUserRefreshTokens({
    userId: user.id,
  });

  return (
    <div className={'mx-auto px-4 py-8 max-w-5xl mt-8 w-full sm:w-auto'}>
      <ConditionalRender condition={!!tokens} fallback={<Loading />}>
        <div>{user.name}</div>
        <SettingsTemplate title={'API Token Management'}>
          <SettingsItem
            title={'Create Token'}
            description={'Generate new refresh tokens for secure access to endpoints.'}
          >
            <CreateTokenCard />
          </SettingsItem>
          <Separator className={'my-12'} />
          <SettingsItem
            title={'Manage Tokens'}
            description={'View, monitor, and revoke your existing tokens.'}
          >
            <ConditionalRender condition={!!tokens && tokens.length > 0}>
              <div className={'flex justify-end mb-4'}>
                <RevokeAllAction />
              </div>
            </ConditionalRender>
            <TokenManagementTable data={tokens} />
          </SettingsItem>
        </SettingsTemplate>
      </ConditionalRender>
    </div>
  );
};
